import React, { memo } from 'react';

import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import { FieldTypesEnum, iframeSizeOptions } from 'constants/loanActionEditor';

import { wrapperClassname } from './LoanActionItem.constants';
import { DynamicValueInput } from './LoanActionItems';

const LoanActionIframeRow = ({ index = 0, rootPath, isDisabled = false, isEditAllowed }) => {
  const fieldPath = `${rootPath}[${index}]`;
  const urlFieldPath = `${fieldPath}.url`;
  const titleFieldPath = `${fieldPath}.title`;
  const sizeFieldPath = `${fieldPath}.size`;

  const disabled = isDisabled || !isEditAllowed;

  return (
    <Box className={wrapperClassname}>
      <DynamicValueInput
        required
        disabled={disabled}
        label="URL (https://)"
        maxLength={2000}
        name={urlFieldPath}
        type={FieldTypesEnum.STRING}
      />
      <DynamicValueInput
        disabled={disabled}
        label="Title (optional)"
        maxLength={200}
        name={titleFieldPath}
        type={FieldTypesEnum.STRING}
      />
      <DynamicValueInput
        disabled={disabled}
        label="Drawer Size"
        name={sizeFieldPath}
        options={iframeSizeOptions}
        type={FieldTypesEnum.SELECT}
      />
    </Box>
  );
};

LoanActionIframeRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  index: PropTypes.number,
  isDisabled: PropTypes.bool,
};

export default memo(LoanActionIframeRow);
